import { createElement } from 'react'
import EC2Optimization from '~/dashboard/aws_master_optimizations/ec2_optimization'
import ReactController from './react_controller'

export default class AWSEc2OptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(EC2Optimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
